// Module
var code = "<session-media-display media=\"$ctrl.media\"></session-media-display><ngx-comment-captions ng-show=\"$ctrl.isCommentCaptionsEnabled()\" [disabled]=\"!$ctrl.isCommentCaptionsEnabled()\" [player]=\"$ctrl.mainController.playerSync\"></ngx-comment-captions>";
// Exports
module.exports = code;